<template>
  <div class="register-container">
    <div class="register-card">
      <h2 class="register-title">Create Account</h2>
      <p class="register-subtitle">Please fill in your information to get started</p>
      
      <form @submit.prevent="register" class="register-form">
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        <div v-if="success" class="success-message">
          {{ success }}
        </div>
        
        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="email" 
            v-model="email" 
            id="email" 
            placeholder="Enter your email"
            required 
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input 
            type="password" 
            v-model="password" 
            id="password" 
            placeholder="Enter your password"
            required 
            class="form-input"
          />
        </div>

        <div class="form-group">
          <label for="customer">Customer</label>
          <input 
            type="text" 
            v-model="customer" 
            id="customer" 
            placeholder="Enter your customer name"
            required 
            class="form-input"
          />
        </div>

        <button type="submit" class="register-button" :disabled="loading">
          {{ loading ? 'Registering...' : 'Register' }}
        </button>

        <p class="login-link">
          Already have an account? 
          <router-link to="/login">Login</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RegisterView',
  data() {
    return {
      email: '',
      password: '',
      customer: '',
      loading: false,
      error: '',
      success: ''
    };
  },
  methods: {
    async register() {
      this.loading = true;
      this.error = '';
      
      try {
        const response = await axios.post('/auth/register', {
          email: this.email,
          password: this.password,
          customer: this.customer
        });
        
        // Show success message about pending approval
        this.success = response.data.message;
        
        // Redirect to login after a delay
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000);
      } catch (error) {
        console.error('Registration error:', error);
        this.error = error.response?.data?.message || 'Registration failed';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.register-container {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: var(--background-alt);
}

.register-card {
  background-color: var(--background);
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 400px;
}

.register-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.register-subtitle {
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
}

.form-input {
  padding: 0.75rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 1rem;
  width: 100%;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.register-button {
  background-color: var(--primary-color);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
}

.register-button:hover {
  background-color: var(--primary-hover);
}

.register-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  margin-top: 1rem;
  text-align: center;
}

.login-link {
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.login-link a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.login-link a:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .register-card {
    padding: 1.5rem;
  }
  
  .register-title {
    font-size: 1.5rem;
  }
}

.success-message {
  background-color: #dcfce7;
  color: #166534;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  text-align: center;
}
</style>
